const styles = theme => ({
  nextprevBtnholder: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    '& $handleDelete': {
      color: theme.palette.primary.main,
      padding: '10px',
      textTransform: 'none',
      minWidth: 'auto',
      height: 'auto',
      '&:hover': {
        background: 'none !important',
        boxShadow: 'none',
      },
    },
    '& button': {
      minWidth: '151px',
      padding: '15px',
      height: '60px',
      fontWeight: '600',
      fontSize: '16px',
      color: '#fff',
      textTransform: 'none',
      '&:hover': {
        boxShadow: '1px 2px 10px rgba(0, 0, 0, 0.3)',
      },
    },
    '& $nextbtn': {
      background: '#0088FF',
      color: '#FFFFFF',
      marginLeft: 'auto',
      boxShadow: 'none !important',
      '&:hover': {
        backgroundColor: theme.palette.primary.adgmHover,
        color: theme.palette.primary.white,
        border: 'none',
      },
    },
    '& $backButton': {
      color: theme.palette.primary.main,
      border: `1px solid ${theme.palette.primary.main}`,
      boxShadow: 'none !important',
      marginRight: '10px',
      '&:hover': {
        '& svg path': {
          fill: theme.palette.primary.white,
        },
        backgroundColor: theme.palette.primary.adgmHover,
        color: theme.palette.primary.white,
        border: 'none',
      },
    },
  },
  rotateArrow: {
    '& img, svg': {
      transform: 'rotate(180deg)',
    },
  },
  nextbtn: { backgroundColor: 'none !important' },
  backButton: {},
  handleDelete: {},
  nextprevBtnholderWithContractPreview: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '16px',
    [theme.breakpoints.down('sm')]: {
      // flexWrap: 'wrap',
      gap: '4px',
      order: 2,
      '& $previewButton': {
        order: 1,
        flexBasis: '100%',
        '& > button': {
          width: '100%',
        },
      },
      '& $backButton': {
        order: 1,
      },
      '& $nextbtn': {
        order: 3,
      },
    },
  },
  previewButton: {
    display: 'flex',
    padding: '16px 40px',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '8px',
    color: '#0D2A3A !important',
    fontSize: '16px !important',
    fontWeight: '600 !important',
    border: '1px solid #0D2A3A !important',
    // [theme.breakpoints.down('sm')]: {
    //   '& span': {
    //     fontSize: '11px',
    //   },
    // },
    '&:hover': {
      background: theme.palette.primary.adgmHover,
      color: `${theme.palette.primary.white} !important`,
      border: 'none !important',
      '& span > svg': {
        // fill: theme.palette.primary.white,
        stroke: theme.palette.primary.white,
      },
    },
  },
  viewIcon: {
    paddingRight: '5px',
  },

  disableBtn: {
    backgroundColor: `${theme.palette.primary.borderColor} !important`,
    color: `${theme.palette.primary.darkGrey} !important`,
    cursor: 'not-allowed !important',
  },
  '@media (max-width:767px)': {
    nextprevBtnholder: {
      position: 'fixed',
      bottom: '0',
      left: '0',
      right: '0',
      background: '#fff',
      padding: '16px 10px',
      boxShadow: '0px -1px 8px rgba(0, 0, 0, 0.1)',
      zIndex: '1021',
      '& button': {
        // width: '100%',
        margin: '0 5px',
        height: '48px',
      },
      '& $nextbtn': {
        margin: '0 5px',
      },
    },
  },
  '@media (max-width:600px)': {
    nextprevBtnholder: {
      bottom: '68px',
    },
  },
  '@media (max-width:431px)': {
    nextprevBtnholder: {
      '& button': {
        minWidth: '100px',
        marginRight: '0px',
      },
      '& $backButton': {
        marginRight: '0px',
      },
    },
  },
});

export default styles;
